import { render, staticRenderFns } from "./ScoreTab.vue?vue&type=template&id=2439bb90&scoped=true&"
import script from "./ScoreTab.vue?vue&type=script&lang=js&"
export * from "./ScoreTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2439bb90",
  null
  
)

export default component.exports